import { ShieldAlert } from 'lucide-react'
import styles from './ChannelChat.module.css'
import chatStyles from '../ChatView.module.css'

/** Экран перед каналом 18+: подтверждение возраста или отказ для тех, кому нет 18. */
export function NsfwGate({ name, allowed, onAccept }: { name: string; allowed: boolean; onAccept: () => void }) {
  return (
    <div className={styles.nsfwGate} role="region" aria-label="Канал 18+">
      <span className={styles.nsfwIcon}><ShieldAlert size={40} /></span>
      <h2 className={chatStyles.welcomeTitle}>#{name} — канал 18+</h2>
      {allowed ? (
        <>
          <p className={chatStyles.welcomeText}>Здесь может быть контент для взрослых. Продолжая, вы подтверждаете, что вам есть 18 лет.</p>
          <button type="button" className={styles.nsfwButton} onClick={onAccept}>Мне есть 18, продолжить</button>
        </>
      ) : (
        <p className={chatStyles.welcomeText}>Канал доступен только с 18 лет по дате рождения в учётной записи.</p>
      )}
    </div>
  )
}
